<template>
  <div class="ml-auto mr-auto">
    <button
      v-if="!showFilters"
      type="text"
      :class="'btn btn-info btn-fill mb-4 w-25 ' + this.filtroAtivo"
      @click.prevent="showFilters = true"
    >Filtros</button>
    <card v-if="showFilters" class="col-xl-10 col-sm-12 ml-auto mr-auto">
      <h4 class="card-title">Filtros</h4>
      <form action="#">
        <div class="row">
          <div class="col-md-6">
            <base-input type="date" label="dataInicial" v-model="filtros.dataInicial"></base-input>
          </div>

          <div class="col-md-6">
            <base-input type="date" label="dataFinal" v-model="filtros.dataFinal"></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <base-input type="text" label="nomeCliente" v-model="filtros.nomeCliente" placeholder="nomeCliente"></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-auto mb-auto p-2 text-center">
            <button
              type="submit"
              class="btn btn-info btn-fill w-100"
              @click.prevent="searchEstatisticas"
            >Pesquisar</button>
          </div>
          <div class="col-6 mt-auto mb-auto p-2 text-center">
            <button
              type="submit"
              class="btn btn-clear w-100"
              @click.prevent="clearFiltros"
            >Limpar Filtros</button>
          </div>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
export default {
  props:['estatisticaInfo'],
  data() {
    return {
      
      name: "filterEstatisticas",
      showFilters: false,
      filtroAtivo: "btn-blue",
      filtros: {
        dataInicial: "",
        dataFinal: "",
        nomeCliente: "",
        breakPoint: ""
      }
    };
  },
  methods: {
    searchEstatisticas() {
      this.$emit("updateFiltrosEstatisticas", this.filtros);
      this.showFilters = false;
      this.checkFiltros();
      // this.clearFiltros();
    },
    clearFiltros() {
      this.filtros = {
        dataInicial: "",
        dataFinal: "",
        nomeCliente: "",
        breakPoint: ""
      };
      this.searchEstatisticas();
    },
    clearPeriodo() {
      this.filtros.dataInicial = "";
      this.filtros.dataFinal = "";
    },
    checkFiltros() {
      let empty = "btn-blue";
      for (const filtro of Object.values(this.filtros)) {
        if (filtro) {
          empty = "btn-red";
          break;
        }
      }

      this.filtroAtivo = empty;
    }
  },
  mounted() {
    this.checkFiltros();
    this.filtros.dataInicial = this.estatisticaInfo.dataInicial;
    this.filtros.dataFinal = this.estatisticaInfo.dataFinal;
  },
  updated() {
    if (this.filtros.tipoBusca == "" || this.filtros.dataInicial == "") {
      this.clearPeriodo();
    }
  }
};
</script>

<style>
.btn-red {
  background-color: #a33623 !important;
  border-color: #99311e !important;
}
.btn-blue {
  background-color: #1dc7ea;
}
.btn-clear {
  background-color: rgb(167, 165, 165);
  border-color: rgb(167, 165, 165);
  color: white;
}
</style>
